<template>
    <div class="card" :class="{ 'clickable': clickable }" @click="handleClick">
        <div class="card-body text-center">
            <div class="kpi" :class="valueColorClass">{{ formattedValue }}</div>
            <div class="kpi-sub">{{ label }}</div>
            <div class="kpi-date">{{ subtitle }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'KpiCard',
    props: {
        value: { type: [String, Number], required: true },
        label: { type: String, required: true },
        subtitle: { type: String, default: 'Current' },
        color: { type: String, default: null, validator: v => !v || ['primary', 'success', 'danger', 'info', 'warning', 'secondary'].includes(v) },
        format: { type: String, default: 'text', validator: v => ['text', 'number', 'percent', 'currency', 'signed'].includes(v) },
        clickable: { type: Boolean, default: false }
    },
    methods: {
        handleClick() {
            if (this.clickable) {
                this.$emit('click')
            }
        }
    },
    computed: {
        valueColorClass() {
            if (this.color) return `text-${this.color}`
            if (this.format === 'signed' && this.value >= 0) return 'text-success'
            if (this.format === 'signed' && this.value < 0) return 'text-danger'
            return ''
        },
        formattedValue() {
            if (this.value === null || this.value === undefined) return '-'

            switch (this.format) {
                case 'number':
                    return Number(this.value).toLocaleString()
                case 'percent':
                    return `${this.value}%`
                case 'currency':
                    return `$${Number(this.value).toLocaleString()}`
                case 'signed':
                    return `${this.value >= 0 ? '+' : ''}${this.value}`
                default:
                    return this.value
            }
        }
    }
}
</script>

<style scoped>
.card.clickable {
    cursor: pointer;
    transition: all 0.2s ease;
}

.card.clickable:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
